"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageV1Factory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var StorageV1Factory = /** @class */ (function (_super) {
    __extends(StorageV1Factory, _super);
    function StorageV1Factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    StorageV1Factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    StorageV1Factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    StorageV1Factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    StorageV1Factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    StorageV1Factory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return StorageV1Factory;
}(contracts_1.ContractFactory));
exports.StorageV1Factory = StorageV1Factory;
var _abi = [
    {
        constant: true,
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "state",
        outputs: [
            {
                internalType: "contract StateV1",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b50610113806100206000396000f3fe6080604052348015600f57600080fd5b506004361060325760003560e01c80635c975abb146037578063c19d93fb146051575b600080fd5b603d6062565b604051604891906093565b60405180910390f35b6057606b565b6040516048919060a5565b60005460ff1681565b60005461010090046001600160a01b031681565b60868160b1565b82525050565b60868160c2565b60208101609f8284607f565b92915050565b60208101609f8284608c565b151590565b6001600160a01b031690565b6000609f826000609f8260b656fea365627a7a7231582098f52220fed345a76991d2285a974be613d38251422c732d1d6b091817eac5bf6c6578706572696d656e74616cf564736f6c63430005100040";
//# sourceMappingURL=StorageV1Factory.js.map